import { render, staticRenderFns } from "./DetailCheck.vue?vue&type=template&id=2625388d"
import script from "./DetailCheck.vue?vue&type=script&lang=js"
export * from "./DetailCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports